import { useEffect, useState } from "react";
import { DashboardLabels } from "../labels/dashboard.labels";
import { useAppSelector } from "../store/hooks";
import { selectLayouts } from "../store/layout/layouts.slice";
import { selectTenantConfig } from "../store/tenant-config/tenant-config.slice";
import _ from "lodash";

export const useMobileVersionLabels = <TLabels>(dashboardLabels: DashboardLabels, labelsKey: string) => {
    const layouts = useAppSelector(selectLayouts);
    const tenantConfig = useAppSelector(selectTenantConfig);

    const getLabels = () => {
        if (!tenantConfig?.layout || !dashboardLabels) {
            return (dashboardLabels as any)[labelsKey];
        }
        const layout=layouts.layouts.find((l:any) => l.layoutId==tenantConfig.layoutId);
        let currentLayoutLabels = dashboardLabels.LAYOUT_SPECIFIC[layout?.name ?? ""];
        if (!currentLayoutLabels) {
            return (dashboardLabels as any)[labelsKey];
        }

        if (currentLayoutLabels.MOBILE_SPECIFIC && currentLayoutLabels.MOBILE_SPECIFIC[labelsKey]) {
            currentLayoutLabels = currentLayoutLabels.MOBILE_SPECIFIC[labelsKey];
        }

        const defaultLabels = _.cloneDeep((dashboardLabels as any)[labelsKey]);

        return _.merge(defaultLabels, currentLayoutLabels);
    };

    const [labels, setLabels] = useState<TLabels>(getLabels());

    useEffect(() => {
        setLabels(getLabels());
    }, [dashboardLabels, tenantConfig]);

    return labels;
}